import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import CmsPageViewModel from './CmsPageViewModel.type';

type CmsPageType = CmsPageViewModel & PageType;

export default (currentPage: PageType): currentPage is CmsPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Cms_CmsPageViewModel;
};
